import {CSSProperties} from "react";

const clearInputButtonContainerStyle: CSSProperties = {
  width: '18px',
  height: '18px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer'
}

const iconStyle: CSSProperties = {
  width: '100%',
  height: '100%'
}

export const styles = {
  ClearInputButtonContainer: clearInputButtonContainerStyle,
  Icon: iconStyle,
}